import React, { useContext, useEffect } from "react";
import '../assets/templates/EndLesson.css';
import lessonEnd from '../assets/images/lesson-end.png';
import { Link } from "react-router-dom";
import { endLesson } from '../service/service';
import ReactGA from 'react-ga';
import { AppGlobalConfigContext } from "../providers/AppGlobalConfigContext";
import { WIZME_URL } from "../helpers/constants";
import {useLessonPlaybackState} from "../hooks/useLessonPlaybackState";
import { t } from "../lib/i18n";

const EndLesson = ({ lessonId, catchupId }) => {
  const context = useContext(AppGlobalConfigContext);
  const { isEmbedMode } = context;
  const { reset } = useLessonPlaybackState();

  useEffect(() => {
      reset();
  }, []);

  // Function to get the current formatted date
  const _getCurrentDate = () => {
    const currentdate = new Date();
    const datetime = currentdate.getFullYear() + "-"
      + (((currentdate.getMonth() + 1) < 10) ? "0" : "") + (currentdate.getMonth() + 1) + "-"
      + ((currentdate.getDate() < 10) ? "0" : "") + currentdate.getDate() + " "
      + ((currentdate.getHours() < 10) ? "0" : "") + currentdate.getHours() + ":"
      + ((currentdate.getMinutes() < 10) ? "0" : "") + currentdate.getMinutes() + ":"
      + ((currentdate.getSeconds() < 10) ? "0" : "") + currentdate.getSeconds();
    return datetime;
  };

  // Function to mark the lesson as completed
  const _endLesson = () => {
    const data = {
      catchUPID: catchupId,
      licaoID: lessonId,
      dataHora: _getCurrentDate(),
    };

    console.log('data: ', data);

    endLesson(data)
      .then(res => console.log('success: ', res))
      .catch(err => console.log('error: ', err));
  };

  // Runs once when the component is mounted (equivalent to componentDidMount)
  useEffect(() => {
    const trackingId = 'UA-1839981-59';
    ReactGA.initialize(trackingId);

    const userInfo = localStorage.getItem('user-info');
    let userId = 'undefined';

    if (userInfo) {
      try {
        const parsedInfo = JSON.parse(userInfo);
        if (parsedInfo && parsedInfo.id) {
          userId = parsedInfo.id;
        } else {
          console.log('ID not found');
        }
      } catch (e) {
        console.log('Error parsing user info:', e);
      }
    } else {
      console.log('User info not found in local storage');
    }

    ReactGA.set({ user_id: userId });

    ReactGA.event({
      category: "Catchup",
      action: "Ended Lesson",
      label: lessonId.toString(),
    });

  }, [lessonId]); // Effect depends on `lessonId`

  // Retrieve lessons and batch information
  const lessons = JSON.parse(sessionStorage.getItem('last-accessed-lessons'));
  const batch = localStorage.getItem('blockName');

  return (
    <div className="default-card workbook-container new-bg-color" style={{ color: "#003057" }}>
      <div>
        <img alt="WorkBook" className="workbook-img" src={lessonEnd} />
      </div>
      <div style={{ marginTop: 15 }}>
        <h2>{t("Continue Praticando!")}</h2>
      </div>
      <div style={{ fontWeight: 'lighter', width: '50%', marginTop: 10, marginBottom: 15 }}>
        {t("Agora que você terminou, aproveite o restante da sua aula para continuar fazendo mais exercícios no Wiz.me.")}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ marginRight: 30 }} className="workbook-button">
          <Link
            to={{ pathname: `${isEmbedMode ? '/embeddable' : ''}/lessonsList`, lessons: lessons, batch: batch }}
            onClick={() => {
              localStorage.setItem('lessons', JSON.stringify(lessons));
              localStorage.setItem('blockName', `Batch: ${batch}`);
            }}
          >
            {t("Voltar para lessons")}
          </Link>
        </div>
        <a className="workbook-button" href={WIZME_URL} target="_blank">
          {t("Acessar exercícios online")}
        </a>
      </div>
    </div>
  );
};

export default EndLesson;